import * as facebookPixel from './facebookPixel';

export { facebookPixel };
